import { useNavigation } from "@react-navigation/native";
import ListItem from "components/atoms/ListItem";
import HStack from "components/atoms/stack/HStack";
import Stack from "components/atoms/stack/Stack";
import VStack from "components/atoms/stack/VStack";
import ThemedBlock from "components/atoms/ThemedBlock";
import ThemedLayout, { createRefreshControl } from "components/atoms/ThemedLayout";
import ThemedList from "components/atoms/ThemedList";
import ThemedLoader from 'components/atoms/ThemedLoader';
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ListItemCredit from "components/molecules/ListItemCredit";
import TimeslotIcon from "components/molecules/TimeslotIcon";
import FooterBar from 'components/organisms/FooterBar';
import _ from "lodash";
import { AppRoutes } from "navigations/app-routes";
import { useMemo, useRef } from "react";
import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import Button from "theme/Button";
import useDeviceSizes from "utils/deviceSizes/useDeviceSizes";
import FetchCreditAmounts from "utils/fetch/FetchCreditAmounts";
import useFetch from "utils/hooks/useFetch";
import i18n from "utils/i18n";
import Translate from "utils/translate";

const HomeMoreCreditsScene = () => {
	
	const navigation = useNavigation();
	const deviceSizes = useDeviceSizes()

	const { data, loading } = useFetch( FetchCreditAmounts.fetchAll );

	const layoutRef = useRef( undefined )

	const dataFiltered = useMemo(() => {
		return _.filter( data, ( item ) => {
			return item.amount_unused > 0 || item.credit_bundle_available_for === 'yes';
		});
	}, [ data ])

	const onPressBuy = ( item ) => {
		navigation.navigate( AppRoutes.MORE_CREDITS_BUY, {
			timeslot_kind_guid: item?.timeslot_kind?.guid
		} );
	}

	const onPressView = ( item ) => {
		navigation.navigate( AppRoutes.MORE_CREDITS_VIEW, {
			timeslot_kind_guid: item?.timeslot_kind?.guid,
		});
	}

	const onPressViewTransactions = () => {
		navigation.navigate( AppRoutes.MORE_CREDITS_TRANSACTIONS );
	}

	const renderItem = ({ item, index }) => {

		return (
			<ListItemCredit
				item={ item }
				accessoryRight={(
					<Stack
						direction={ deviceSizes.isMobile ? "column-reverse" : "row" }>

						<Button 
							appearance="ghost"
							onPress={ onPressView.bind( this, item ) }>
							
							{ i18n.t( 'buttons.view' ) }
						</Button>
						<Button 
							onPress={ onPressBuy.bind( this, item ) }>
							
							{ i18n.t( 'buttons.buy' ) }
						</Button>
					</Stack>
				)}
			/>
		)
	}

	return (
		<ThemedSafeAreaComponentTop 
			top={false}>
			
			<ThemedLayout
				ref={ layoutRef }
				topNavigation={ true }
				showBackButton
				enableFooterBar={ true }
				title={ i18n.t( 'titles.credits' ) }
				scrollViewProps={{
					...createRefreshControl({
						// onRefresh: reloadMessages.bind( this )
					})
				}}>

				{ loading && (
					<ThemedLoader text={ i18n.t( 'basic.loading' ) } />
				)}
				
				<VStack>
					<ThemedBlock 
						shadow>
					
						<ThemedList
							data={ dataFiltered }
							renderItem={ renderItem.bind( this ) }
							scrollEnabled={ false }
						/>
					</ThemedBlock>

					<View style={styles.viewAlignItemsCenter}>
						<Button
							onPress={ onPressViewTransactions }
							appearance="ghost">

							{ i18n.t( 'page.credits.transactions' ) }
						</Button>
					</View>
				</VStack>
			</ThemedLayout>

			{ !loading && (
				<FooterBar
					buttons={(
						<Button
							onPress={ onPressBuy }>

							{ i18n.t( 'page.credits.buy' ) }
						</Button>
					)}
					onHeightCallback={ layoutRef.current?.setFooterHeight }
				/>
			)}
		</ThemedSafeAreaComponentTop>
	);
}

const styles = StyleSheet.create({
	viewAlignItemsCenter: {
		alignItems: 'center',
	},
	iconContainer: {
		width: 40,
		height: 40,
	},
	iconInner: {
		transform: [ {
			scale: 0.6
		} ],
	}
})

export default HomeMoreCreditsScene;
